import { QuotesSubTabs } from '../enums'

/**
 * Type definition for status filter result item
 */
export type StatusFilterResult = {
  key: string
  value: string
  text?: string
  count?: number
  summary?: string | null
}

/**
 * Orders status results based on the current subtab
 * @param results The status results to order
 * @param subTab The current subtab
 * @returns The ordered results
 */
export const handleQuotationStatusesOrder = (
  results: StatusFilterResult[],
  subTab: QuotesSubTabs
): StatusFilterResult[] => {
  const orderedResults = [...results]
  let statusOrder: string[] = []

  switch (subTab) {
    case QuotesSubTabs.DRAFTS: {
      statusOrder = ['Draft', 'Price_changed', 'Needs_revising']

      break
    }
    case QuotesSubTabs.CUSTOMER_APPROVALS: {
      statusOrder = [
        'DraftSentToCustomer',
        'DraftAcceptedByCustomer',
        'DraftAcceptedOnBehalfOfCustomer',
        'DraftRejectedByCustomer'
      ]

      break
    }

    case QuotesSubTabs.INTERNAL_APPROVALS: {
      statusOrder = [
        'PendingLevel1Approval',
        'Level1ApprovedPendingLevel2Approval',
        'Rejected_Internal_L1',
        'PendingLevel2Approval',
        'Rejected_Internal_L2'
      ]

      break
    }
  }

  return orderedResults.sort((a, b) => {
    const indexA = statusOrder.indexOf(a.value)
    const indexB = statusOrder.indexOf(b.value)
    return indexA - indexB
  })
}

/**
 * Comprehensive status ordering for the customer profile quotes view
 * @param results The status results to order
 * @returns The ordered results
 */
export const handleCustomerQuotesStatusesOrder = (
  results: StatusFilterResult[]
): StatusFilterResult[] => {
  // Create a copy of the results to avoid mutating the original array
  const orderedResults = [...results]

  // Define the comprehensive status order as shown in the image
  const statusOrder = [
    'Draft',
    'Price_changed',
    'Needs_revising',
    'DraftSentToCustomer',
    'DraftAcceptedByCustomer',
    'DraftAcceptedOnBehalfOfCustomer',
    'DraftRejectedByCustomer',
    'PendingLevel1Approval',
    'Level1ApprovedPendingLevel2Approval',
    'Rejected_Internal_L1',
    'PendingLevel2Approval',
    'Rejected_Internal_L2',
    'Accepted',
    'Archived'
  ]

  // Sort results according to the defined order
  orderedResults.sort((a, b) => {
    const indexA = statusOrder.indexOf(a.value)
    const indexB = statusOrder.indexOf(b.value)
    return indexA - indexB
  })

  return orderedResults
}
